'use strict';

/** Admin Problem Intelligence operations dashboard path. */
export const ADMIN_PROBLEM_INTELLIGENCE_OPS_PATH = '/admin/problem-intelligence';

export const PI_BACKFILL_POLL_MS = 5000;

export const PI_BACKFILL_STAGES = Object.freeze([
  'queued',
  'running',
  'identity',
  'catalog',
  'occurrence',
  'completed',
]);
